import { Component, ViewChild } from '@angular/core';
import { App, Nav } from 'ionic-angular';
import { AuthService } from "../providers/auth.service";
import { SearchService } from "../providers/search.service";
import { IFilter, FilterService } from "../providers/filter.service";
import { ConfigService } from "../providers/config.service";

declare let ga;

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = 'home';

  searchTerm: string = '';
  isLoading: boolean = true;

  filter: IFilter;

  housingFilterCount: number;
  jobFilterCount: number;
  saleFilterCount: number;
  helpFilterCount: number;
  isLoggedIn: boolean;


  pages: Array<{ title: string, component: any, icon: string }>;

  constructor(private app: App, private _authService: AuthService, private _searchService: SearchService, public _filterService: FilterService, public _config: ConfigService) {

    this._authService.setConfig({ // TODO: THIS IS ALSO SET IN AUTH SERVICE AS A WORKAROUND WITH FILTER SERVICE ERROR
      baseUrl: this._config.baseUrl + '/api/',
      baseVersion: this._config.baseVersion,
      anonymousDomain: this._config.anonymousDomain,
      debug: true
    });

    this.isLoggedIn = !!+localStorage.getItem('isLoggedIn');

    this._filterService.filterSubject.subscribe(filter => {
      this.filter = filter;
    });

    this._searchService.searchStore.subscribe((data) => {
      if (data === null) return; // Initial data, no search results

      this.searchTerm = this._searchService.getSearchTerm();

      this.isLoading = false;

      this.housingFilterCount = data.num_housing;
      this.jobFilterCount = data.num_job;
      this.saleFilterCount = data.num_sale;
      this.helpFilterCount = data.num_help;
    });

    this._searchService.loadingStore.subscribe((data) => {
      this.isLoading = data;
    });

    this.app.viewDidEnter.subscribe(res => {
      if (res) {
        ga('set', 'page', res.name);
        ga('send', 'pageview');
      }
    });

    this.initializeApp();

    // used for an example of ngFor and navigation
    if (this.isLoggedIn) {
      this.pages = [
        { title: 'Entdecken', component: 'home', icon: 'md-eye' },
        { title: 'Inserat erstellen', component: 'create-landing', icon: 'md-add-circle' },
        { title: 'Suchabo', component: 'home', icon: 'md-notifications' },
        { title: 'Profil', component: 'profile', icon: 'md-contact' }
      ];
    }
    else {
      this.pages = [
        { title: 'Entdecken', component: 'home', icon: 'md-eye' },
        { title: 'Inserat erstellen', component: 'login', icon: 'md-add-circle' },
        { title: 'Suchabo', component: 'login', icon: 'md-notifications' },
        { title: 'Anmelden', component: 'login', icon: 'md-contact' }
      ];
    }

  }

  initializeApp() {

    if (localStorage.getItem('isLoggedIn') === null) {
      localStorage.setItem('isLoggedIn', '0');
    }

    // this.platform.ready().then(() => {
    //   // Okay, so the platform is ready and our plugins are available.
    //   // Here you can do any higher level native things you might need.
    //   this.statusBar.styleDefault();
    //   this.splashScreen.hide();
    // });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  onInput() {
    this._searchService.setSearchTerm(this.searchTerm);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts